export { default } from './AvisCookies.jsx';
